import React from "react";
import classnames from "classnames";
import {DealModal} from "../PricingListPage/DealModal";
import {useModalsStore} from "../../stores/modalsStore";
import {useListDealsStore} from "../../stores/listDealsStore";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";

// One row of the List view. Mirrors ListDealCard's open-on-click behavior.
export const ListDealRow = ({deal, isSelected}) => {
    const isTabletOrMobile = useMediaQuery({query: mediaQueryForMobile})
    const openModal = useModalsStore((state) => state.openModal)
    const updateDealFromBackend = useListDealsStore((state) => state.updateDealFromBackend)

    const car = deal.car_detail
    const quote = deal.formatted_quote || {}
    const isPurchase = deal.is_purchase
    const isCash = isPurchase && deal.is_one_pay
    const type = isCash ? 'CASH' : isPurchase ? 'FINANCE' : 'LEASE'

    const expirationDate = quote?.expiration_date
    const isExpired = Boolean(
        expirationDate &&
        new Date(expirationDate).setUTCHours(0, 0, 0, 0) <= new Date().setUTCHours(0, 0, 0, 0)
    )

    const dollar = (v) => (v === null || v === undefined || v === '') ? '—' : `$${v}`

    const open = () => {
        if (isTabletOrMobile) {
            window.open(`/quotes/${deal.id}`, "_self")
            return
        }
        openModal({
            element: DealModal,
            id: "DealModal",
            props: {
                id: deal.id,
                onSave: (newDealState) => updateDealFromBackend(newDealState),
            },
        })
    }

    return (
        <tr className={classnames('lv-row', {selected: isSelected})} onClick={open}>
            <td className={'lv-vehicle'}>
                {car.year} {car.make} {car.model}{car.is_new ? '' : ' [Used]'}
            </td>
            <td className={'lv-spec'}>{car.trim}</td>
            <td className={'lv-lender'}>{quote.lender_name}</td>
            <td>
                <span className={classnames('lv-type-badge', {
                    'lv-lease': type === 'LEASE',
                    'lv-finance': type === 'FINANCE',
                    'lv-cash': type === 'CASH',
                })}>
                    {type}
                </span>
            </td>
            <td>
                <div className={'lv-status'}>
                    <span className={classnames('lv-dot', isExpired ? 'lv-dot-expired' : 'lv-dot-active')}/>
                    <span className={isExpired ? 'lv-expired' : 'lv-active'}>{isExpired ? 'Expired' : 'Active'}</span>
                </div>
            </td>
            <td>{dollar(deal.msrp)}</td>
            <td>{dollar(quote.amount_due_at_signing)}</td>
            <td>{isCash ? '—' : dollar(quote.monthly_payment)}</td>
            {/* Finance loans have a term too — only Cash (one-pay) has none. */}
            <td>{isCash ? '—' : (deal.term || '—')}</td>
            {/* Mileage is lease-only — Finance and Cash have no mileage limit. */}
            <td>{isPurchase ? '—' : (deal.mileage || '—')}</td>
            <td className={'lv-profit'}>{dollar(deal.profit)}</td>
        </tr>
    )
}
